import React, { useCallback, useState } from 'react';

const StarRating = React.memo(({ score, onScoreChange, remarks, onRemarksChange, label, remarksName, required }) => {
  return (
    <div className="form-group">
      <label className="label">
        {label}
        {required && <span className="mandatory">*</span>}
      </label>

      <div className="star-with-remarks">
        <div className="star-rating">
          {[...Array(10)].map((_, index) => {
            const value = index + 1;
            return (
              <span
                key={value}
                className={`star ${value <= score ? "filled" : ""}`}
                onClick={() => onScoreChange(value)}
                style={{ cursor: 'pointer' }}
              >
                ★
              </span>
            );
          })}
        </div>

        {remarksName && (
          <div style={{ width: "100%" }}>
            <input
              type="text"
              name={remarksName}
              value={remarks || ''}
              onChange={onRemarksChange}
              placeholder={`Add remarks for ${label.toLowerCase()}`}
              className="star-input"
              required={required}   // ⭐ MANDATORY IF SCORE > 0
            />

            {/* ⚠ Error Message */}
            {required && !remarks && (
              <span className="error-text">* Remarks are required</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
});


const PerformanceSection = ({ formData, onFormDataChange, isExpanded = true }) => {
 const [mockCount, setMockCount] = useState(1); 
  const technologyRequired = formData.technicalScore > 0;
  const communicationRequired = formData.communicationScore > 0;

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    onFormDataChange(prev => ({ ...prev, [name]: value }));
  }, [onFormDataChange]);

  const setTechnicalScore = useCallback((value) => {
    onFormDataChange(prev => ({ ...prev, technicalScore: value }));
  }, [onFormDataChange]);

  const setCommunicationScore = useCallback((value) => {
    onFormDataChange(prev => ({ ...prev, communicationScore: value }));
  }, [onFormDataChange]);

  const onTechnologyRemarksChange = useCallback((e) => {
    onFormDataChange(prev => ({ ...prev, technologyRemarks: e.target.value }));
  }, [onFormDataChange]);

  const onCommunicationRemarksChange = useCallback((e) => {
    onFormDataChange(prev => ({ ...prev, communicationRemarks: e.target.value }));
  }, [onFormDataChange]);

  const addMockTestScore = () => {
    if (mockCount < 3) {
      const next = mockCount + 1;
      setMockCount(next);
      onFormDataChange(prev => ({ ...prev, [`mockTest${next}Score`]: 0 }));
    }
  };

  const removeMockTestScore = (i) => {
    setMockCount(prev => prev - 1);
    onFormDataChange(prev => {
      const updated = { ...prev };
      delete updated[`mockTest${i}Score`];
      return updated;
    });
  };

  const setMockScore = useCallback((i, value) => {
    onFormDataChange(prev => ({ ...prev, [`mockTest${i}Score`]: value }));
  }, [onFormDataChange]);

  return (
    <div className="form-section">
      {isExpanded && (
        <div className="section-content">
          <div className="form-row">
            <StarRating
              score={formData.technicalScore || 0}
              onScoreChange={setTechnicalScore}
              remarks={formData.technologyRemarks}
              onRemarksChange={onTechnologyRemarksChange}
              label="Technology Score"
              remarksName="technologyRemarks"
              required={technologyRequired}
            />
            <StarRating
              score={formData.communicationScore || 0}
              onScoreChange={setCommunicationScore}
              remarks={formData.communicationRemarks}
              onRemarksChange={onCommunicationRemarksChange}
              label="Communication Score"
              remarksName="communicationRemarks"
              required={communicationRequired}
            />

          </div>

          {/* Dynamic Mock Test Scores as Stars */}
          <div className="form-row">
            {[...Array(mockCount)].map((_, index) => {
              const i = index + 1;
              return (
                <div className="mock-score-wrapper" key={i} style={{ position: 'relative', marginRight: '20px' }}>
                  <StarRating
                    score={formData[`mockTest${i}Score`] || 0}
                    onScoreChange={(value) => setMockScore(i, value)}
                    label={`Mock Test ${i} Score`}
                  />
                  <button
                    type="button"
                    onClick={() => removeMockTestScore(i)}
                    style={{
                      position: 'absolute',
                      top: '-5px',
                      right: '-5px',
                      background: 'red',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: '20px',
                      height: '20px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      lineHeight: '18px',
                      textAlign: 'center'
                    }}
                  >
                    ×
                  </button>
                </div>
              );
            })}
          </div>

          {mockCount < 3 && (
            <button type="button" onClick={addMockTestScore} className="add-btn">
              Add Mock Test Score
            </button>
          )}

          {/* Mock Interview */}
          <div className="form-row">
            <div className="form-group">
              <label className="label">Mock Interview <span className="mandatory">*</span></label>
              <select
                name="mockInterview"
                value={formData.mockInterview || ''}
                onChange={handleChange}
                required
                className="input select"
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            {formData.mockInterview === "Yes" && (
              <div className="form-group">
                <label className="label">Mock Interview Remarks <span className="mandatory">*</span></label>
                <input
                  type="text"
                  name="mockRemarks"
                  value={formData.mockRemarks || ''}
                  onChange={handleChange}
                  required
                  className="input"
                  placeholder="Enter remarks"
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PerformanceSection;
